import type { IntercomConfig } from '@/types/intercom';

let cachedIntercomConfig: IntercomConfig | null = null;

export const configService = {
  async getIntercomConfig(): Promise<IntercomConfig> {
    if (cachedIntercomConfig) {
      return cachedIntercomConfig;
    }

    const defaultIntercomConfig: IntercomConfig = { appId: '' };

    try {
      const response = await fetch('/config/intercom.config.json');
      if (!response.ok) {
        return defaultIntercomConfig;
      }

      cachedIntercomConfig = await response.json();
      return cachedIntercomConfig!;
    } catch {
      return defaultIntercomConfig;
    }
  },

  clearCache(): void {
    cachedIntercomConfig = null;
  },
};
